import React, { useEffect, useState } from 'react';
import { estadoRedes, conectarRedes, elegirPaginaRedes, desconectarRedes } from '../services/publicarService';
import { getNegocioId } from '../services/negocioActual';
import { getMarcaId } from '../services/marcaActual';
import { mensajeAmigable } from '../utils/errores';

// "Mis redes sociales": la dueña conecta SU Facebook e Instagram con el inicio
// de sesión oficial de Facebook para publicar desde Kontrol (sql/109).
// aviso = true: versión corta para Contenido; solo aparece si falta conectar.
// enContenido = true: al volver de Facebook se abre Contenido → Mi marca (no Configuración).

const ROSA = 'var(--color-primario,#DB2777)';
const MUTED = 'var(--k-muted, #6B7280)';
const btn = (off) => ({
  padding: '10px 18px', borderRadius: '999px', border: 'none', background: ROSA, color: '#fff',
  fontWeight: 700, cursor: off ? 'default' : 'pointer', opacity: off ? 0.6 : 1, fontFamily: 'inherit', fontSize: '14px',
});
const caja = { border: '1px solid #F3E8FF', background: '#FCFAFF', borderRadius: '14px', padding: '14px 16px', marginBottom: '16px' };

export default function MisRedesSociales({ aviso = false, onIrConfiguracion, marca = null, enContenido = false }) {
  const [estado, setEstado] = useState(null); // respuesta de meta_estado
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState(null);
  const [pagina, setPagina] = useState('');
  const [confirmar, setConfirmar] = useState(false);

  const cargar = () => Promise.resolve().then(() => estadoRedes({ negocioId: getNegocioId() }))
    .then((e) => { setEstado(e); setPagina(e.opciones?.[0]?.id || ''); })
    .catch(() => setEstado({ oculto: true })); // equipo (no dueña) u otro error: no se muestra
  useEffect(() => { cargar(); }, []);

  const hacer = async (fn, despues = cargar) => {
    setOcupado(true); setError(null);
    try { await fn(); await despues(); } catch (e) { setError(e?.message || mensajeAmigable(e)); }
    setOcupado(false);
  };
  // Se va a Facebook. Si a los 6 s la página sigue aquí (el navegador no abrió
  // Facebook), se reactiva el botón con un aviso para tocarlo otra vez.
  const conectar = async () => {
    setOcupado(true); setError(null);
    try {
      try { if (enContenido) sessionStorage.setItem('kontrol-meta-volver', getMarcaId() || 'contenido'); } catch { /* sin almacenamiento */ }
      await conectarRedes({ negocioId: getNegocioId() });
      setTimeout(() => { setOcupado(false); setError('¿No se abrió Facebook? Toca el botón otra vez.'); }, 6000);
    } catch (e) {
      setError(e?.message || mensajeAmigable(e)); setOcupado(false);
    }
  };

  if (!estado || estado.oculto) return null;
  const conectado = estado.estado === 'activa';
  if (aviso && (conectado || !estado.disponible)) return null;

  if (aviso) {
    return (
      <div className="kc-card" style={{ borderColor: '#FBCFE8', marginBottom: '14px' }}>
        <b style={{ fontSize: '15px' }}>🔗 Conecta tu Facebook e Instagram</b>
        <p style={{ fontSize: '13.5px', color: MUTED, margin: '4px 0 10px' }}>
          Así publicas y programas desde Kontrol directo en tus redes, y ves cómo le fue a cada publicación.
        </p>
        <button style={btn(ocupado)} disabled={ocupado} onClick={estado.estado === 'elegir' && onIrConfiguracion ? onIrConfiguracion : conectar}>
          {estado.estado === 'elegir' ? 'Terminar de conectar' : ocupado ? 'Abriendo Facebook…' : 'Conectar ahora'}
        </button>
        {error && <div style={{ fontSize: '13px', color: '#991B1B', marginTop: '8px' }}>⚠️ {error}</div>}
      </div>
    );
  }

  return (
    <div style={caja}>
      <b style={{ fontSize: '15px', display: 'block', marginBottom: '4px' }}>🔗 {marca ? `Redes de ${marca}` : 'Mis redes sociales'}</b>

      {conectado && estado.origen === 'kontrol' && (
        <p style={{ fontSize: '13.5px', margin: 0 }}>✅ Tu Facebook e Instagram están conectados. Puedes publicar y programar desde Kontrol.</p>
      )}

      {conectado && estado.origen === 'propia' && (
        <>
          <p style={{ fontSize: '13.5px', margin: '0 0 8px' }}>
            ✅ Conectado: página <b>{estado.pagina}</b>{estado.instagram ? <> · Instagram <b>@{estado.instagram}</b></> : <> · <span style={{ color: '#B45309' }}>sin Instagram vinculado</span></>}
          </p>
          {!estado.instagram && (
            <p style={{ fontSize: '12.5px', color: '#B45309', margin: '0 0 8px' }}>
              Para publicar en Instagram, pasa tu Instagram a cuenta profesional, vincúlalo a esta página de Facebook y vuelve a conectar.
            </p>
          )}
          {!confirmar ? (
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <button className="k-btn-soft" disabled={ocupado} onClick={conectar}>🔄 Cambiar de página</button>
              <button className="k-btn-soft" disabled={ocupado} onClick={() => setConfirmar(true)}>Desconectar</button>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', fontSize: '13.5px' }}>
              ¿Desconectar? Lo programado no se publicará hasta que vuelvas a conectar.
              <button style={btn(ocupado)} disabled={ocupado} onClick={() => hacer(() => desconectarRedes({ negocioId: getNegocioId() })).then(() => setConfirmar(false))}>Sí, desconectar</button>
              <button className="k-btn-soft" onClick={() => setConfirmar(false)}>No</button>
            </div>
          )}
        </>
      )}

      {estado.estado === 'elegir' && (
        <>
          <p style={{ fontSize: '13.5px', margin: '0 0 8px' }}>Tienes varias páginas de Facebook. ¿Con cuál publicas los productos de este negocio?</p>
          {(estado.opciones || []).map((o) => (
            <label key={o.id} style={{ display: 'flex', gap: '8px', alignItems: 'center', fontSize: '14px', marginBottom: '6px', cursor: 'pointer' }}>
              <input type="radio" name="pagina-meta" checked={pagina === o.id} onChange={() => setPagina(o.id)} />
              <span><b>{o.nombre}</b>{o.igUsuario ? ` · Instagram @${o.igUsuario}` : ' · sin Instagram vinculado'}</span>
            </label>
          ))}
          <button style={btn(ocupado || !pagina)} disabled={ocupado || !pagina} onClick={() => hacer(() => elegirPaginaRedes({ negocioId: getNegocioId(), pageId: pagina }))}>
            {ocupado ? 'Guardando…' : 'Usar esta página'}
          </button>
        </>
      )}

      {estado.estado === 'sin_conectar' && !estado.disponible && (
        <p style={{ fontSize: '13.5px', color: MUTED, margin: 0 }}>Muy pronto podrás conectar tu Facebook e Instagram para publicar y programar desde Kontrol.</p>
      )}

      {estado.estado === 'sin_conectar' && estado.disponible && (
        <>
          <p style={{ fontSize: '13.5px', margin: '0 0 8px' }}>Conecta tus redes para publicar y programar tus productos y servicios desde Kontrol, y ver cómo le va a cada publicación.</p>
          <div style={{ fontSize: '12.5px', color: MUTED, margin: '0 0 10px' }}>
            <b>Antes de conectar, revisa:</b>
            <ol style={{ margin: '4px 0 0', paddingLeft: '18px' }}>
              <li>Tu Instagram es <b>profesional</b> (empresa o creador): en Instagram → Configuración → Tipo de cuenta.</li>
              <li>Está <b>vinculado a la página de Facebook</b> de tu negocio: en Instagram → Configuración → Centro de cuentas.</li>
              <li>Entras con el Facebook que <b>administra</b> esa página.</li>
            </ol>
          </div>
          <button style={btn(ocupado)} disabled={ocupado} onClick={conectar}>{ocupado ? 'Abriendo Facebook…' : '🔗 Conectar mi Facebook e Instagram'}</button>
          <p style={{ fontSize: '12px', color: MUTED, margin: '8px 0 0' }}>Se abre Facebook para que des permiso. Kontrol nunca ve tu contraseña y solo publica lo que tú apruebas.</p>
        </>
      )}

      {error && <div style={{ fontSize: '13px', color: '#991B1B', marginTop: '8px' }}>⚠️ {error}</div>}
    </div>
  );
}
